import { Routes, RouterModule } from '@angular/router';

import { AuthGuard } from '../shared/authentication/auth-guard';
import { Perfis } from '../../models/perfis';

import { GerenciarEtapasComponent } from './gerenciar-etapas/gerenciar-etapas.component';
import { ConvocarAlunoComponent } from './convocar-aluno/convocar-aluno.component';
import { AnalisarDocumentacaoComponent } from './analisar-documentacao/analisar-documentacao.component';

const EtapaRoutes: Routes = [
    { path: 'gerenciar-etapas', component: GerenciarEtapasComponent, canActivate: [ AuthGuard ] },
    {
        path: 'convocar-aluno',
        component: ConvocarAlunoComponent,
        canActivate: [ AuthGuard ],
        data: { roles: [
            Perfis.AdministradorSistema, Perfis.GestorDex, Perfis.AdministrativoDex,
            Perfis.GestorUnidadeOperacional, Perfis.AdministrativoUnidadeOperacional
        ]}
    },
    { path: 'analisar-documentacao/:idCandidato', component: AnalisarDocumentacaoComponent, canActivate: [ AuthGuard ] },
];

export const EtapaRouting = RouterModule.forChild(EtapaRoutes);



// WEBPACK FOOTER //
// ./src/app/components/etapa/etapa.routing.ts